const Alchemy = require('../ability_trees/Alchemy.js');
const Conjuration = require('../ability_trees/Conjuration.js');
const Spirit = require('../ability_trees/Spirit.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator.js');
const LightHelmet = require('../../game_items/equipment/helmet/LightHelmet.js');
const LightTorsoe = require('../../game_items/equipment/torsoe/LightTorsoe.js');
const LightBoots = require('../../game_items/equipment/boots/LightBoots.js');
const Staff = require('../../game_items/equipment/weapon/Staff.js');
const Book = require('../../game_items/equipment/off_hand/Book.js');

module.exports = {
  handle: 'invoker',
  getAbilityTrees: () => ([
    Alchemy,
    Conjuration,
    Spirit,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 10,
    perception: 7,
    mana: 10,
    toughness: 5,
    strength: 5,
    willpower: 7,
    dexterity: 6,
  }),
  getDefaultAIConfig: () => (['support', 'dps_ranged', 'interference', 'dps_close', 'tank']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(LightHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(LightTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(LightBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Staff, 0, 0.1, true),
    off_hand: ItemGenerator.getRandomItem(Book, 0, 0.1, true),
  }),
};
